import { Project } from 'lib/project/types.d'
import { Environments } from 'lib/environments/types.d'
import { getDomainForVariable, getValueForVariable } from 'lib/project/getters'

const getCurrentValueForVariable = (
  variableRef: Project.GenericRef<Project.EnvironmentVariable>,
  objects: Project.ObjectMap,
  currentEnvMap: Environments.CurrentEnvironmentMap,
): Project.EnvironmentVariableValue | null => {
  const domain = getDomainForVariable(variableRef, objects)
  if (!domain) {
    return null
  }
  const environmentUuid = currentEnvMap[domain.uuid]
  if (!environmentUuid) {
    return null
  }
  const environmentRef: Project.GenericRef<Project.Environment> = {
    ref: environmentUuid,
  }
  return getValueForVariable(variableRef, environmentRef, objects)
}

export default getCurrentValueForVariable
